import { useEffect, useId, useState } from 'react';

import styles from './AccordionLegacy.module.css';

import { Spacing } from '../../../styles';
import { Divider } from '../../Divider';
import type { AccordionLegacyProps } from '../Accordion';
import { AccordionRow } from './AccordionRow';
import { getId } from './getId';
import { useKeyboardNavigation } from './useKeyboardNavigation';

/**
 * The Accordion displays information and allows specific rows of information to
 * either be open or closed with a toggle.
 *
 * @deprecated Use {@link AccordionItem} instead.
 */
export function AccordionLegacy(props: AccordionLegacyProps) {
  const accordionId = useId();
  const isSingleItem = props.rows.length === 1;
  const headingId = getId('label', accordionId, 0);
  const [rows, setRows] = useState(props.rows);
  const { handleKeyDown } = useKeyboardNavigation(accordionId, rows);

  useEffect(() => setRows(props.rows), [props.rows]);

  return (
    <section className={styles.container} aria-labelledby={headingId}>
      {rows.map((row, index) => (
        <AccordionRow
          key={index}
          row={row}
          index={index}
          accordionId={accordionId}
          isSingleItem={isSingleItem}
          handleKeyDown={handleKeyDown}
        />
      ))}
      <Divider
        width={1}
        orientation="horizontal"
        spacing={Spacing.MD}
        color="Charcoal0"
      />
    </section>
  );
}
